import PropTypes from 'prop-types'
import React, { useState, useEffect, useRef } from "react"
import { connect } from "react-redux"
import { Link, useNavigate } from "react-router-dom"

// Reactstrap
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap"

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown"
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import ThemeToggle from "../ThemeToggle"

// Lucide icons for modern look
import { Menu, Search, Maximize, Settings, HelpCircle } from 'lucide-react'

import logo from "../../assets/images/logo-sm.png"
import logoLightPng from "../../assets/images/logo-light.png"
import logoDark from "../../assets/images/logo-dark.png"

//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions"

// Import sidebar data for search
import { SIDEBARDATA } from "../Common/Constant"

const Header = props => {
  const navigate = useNavigate()
  const [search, setsearch] = useState(false)
  const [createmenu, setCreateMenu] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const [searchResults, setSearchResults] = useState([])
  const [showResults, setShowResults] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(-1)
  const searchRef = useRef(null)
  const resultsRef = useRef(null)

  // const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  // Filter menu items based on search query
  useEffect(() => {
    if (searchValue.trim().length > 0) {
      const filtered = SIDEBARDATA.filter(item =>
        item.name.toLowerCase().includes(searchValue.toLowerCase())
      )
      setSearchResults(filtered)
      setShowResults(true)
      setSelectedIndex(-1)
    } else {
      setSearchResults([])
      setShowResults(false)
      setSelectedIndex(-1)
    }
  }, [searchValue])

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowResults(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  // Handle keyboard navigation
  const handleKeyDown = (e) => {
    if (!showResults || searchResults.length === 0) return

    switch(e.key) {
      case 'ArrowDown':
        e.preventDefault()
        setSelectedIndex(prev =>
          prev < searchResults.length - 1 ? prev + 1 : prev
        )
        break
      case 'ArrowUp':
        e.preventDefault()
        setSelectedIndex(prev => prev > 0 ? prev - 1 : -1)
        break
      case 'Enter':
        e.preventDefault()
        if (selectedIndex >= 0 && searchResults[selectedIndex]) {
          handleNavigate(searchResults[selectedIndex])
        } else if (searchResults.length > 0) {
          handleNavigate(searchResults[0])
        }
        break
      case 'Escape':
        e.preventDefault()
        setShowResults(false)
        setSearchValue("")
        break
      default:
        break
    }
  }

  // Navigate to selected page
  const handleNavigate = (item) => {
    if (item.external) {
      window.open(item.route, '_blank', 'noopener,noreferrer')
    } else {
      navigate(item.route)
    }
    setShowResults(false)
    setSearchValue("")
    setSelectedIndex(-1)
  }

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  function tToggle() {
    var body = document.body;
    body.classList.toggle("vertical-collpsed");
    body.classList.toggle("sidebar-enable");
  }
  return (
    <React.Fragment>
      <header id="page-topbar" className="modern-header">
        {/* Search Bar - Left */}
        <div className="modern-search-container" ref={searchRef}>
          <Search size={18} className="modern-search-icon" />
          <input
            type="text"
            className="modern-search-input"
            placeholder="Search pages..."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={handleKeyDown}
            onFocus={() => searchValue && setShowResults(true)}
          />
          <kbd className="modern-search-kbd">⌘ F</kbd>

          {/* Search Results Dropdown */}
          {showResults && searchResults.length > 0 && (
            <div className="modern-search-dropdown" ref={resultsRef}>
              {searchResults.map((item, index) => (
                <div
                  key={item.pageCode}
                  className={`modern-search-item ${index === selectedIndex ? 'selected' : ''}`}
                  onClick={() => handleNavigate(item)}
                  onMouseEnter={() => setSelectedIndex(index)}
                >
                  <div className="modern-search-item-icon">
                    <Search size={16} />
                  </div>
                  <div className="modern-search-item-content">
                    <div className="modern-search-item-name">{item.name}</div>
                    <div className="modern-search-item-route">{item.route}</div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* No Results */}
          {showResults && searchValue && searchResults.length === 0 && (
            <div className="modern-search-dropdown">
              <div className="modern-search-no-results">
                No pages found
              </div>
            </div>
          )}
        </div>

        {/* Header Actions - Right */}
        <div className="modern-header-actions">
          {/* Theme Toggle */}
          <ThemeToggle />

          {/* Profile Menu */}
          <ProfileMenu />
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
}

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
